import { FMMetadataEntry, SignableDocumentState } from './reducer'

export const getSignableDocuments = (state: {
  signableDocuments: SignableDocumentState
}) => state.signableDocuments.signableDocuments

export const getLockedFMMetadatas = (state: {
  signableDocuments: SignableDocumentState
}) => state.signableDocuments.lockedFMMetadatas

export const getSignableDocumentsGenerating = (state: {
  signableDocuments: SignableDocumentState
}) => state.signableDocuments.isGenerating

/** Changes on every successful document regeneration — a refetch trigger for
 * AA Document Metadata, which is fetched per component rather than stored. */
export const getDocumentsRegeneratedCount = (state: {
  signableDocuments: SignableDocumentState
}) => state.signableDocuments.regeneratedCount

const defaultFMMetadataEntry: FMMetadataEntry = { data: null, isLoading: false, error: null }

export const getFMMetadataForSubTrade = (
  state: { signableDocuments: SignableDocumentState },
  subTradeId: string,
): FMMetadataEntry =>
  state.signableDocuments.fmMetadataBySubTrade[subTradeId] ?? defaultFMMetadataEntry

